import * as XLSX from 'xlsx';

const COLUMNAS = [
  '#',
  'Ciclo Escolar',
  'Matrícula',
  'Nombre',
  'Sección',
  'Programa',
  'Tipo de Estudiante',
  'Turno',
  'Modalidad',
  'Estatus',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteEstudiantesInscritosXLS({
  resultados = [],
  cicloInicial = '',
  cicloFinal = '',
} = {}) {
  const aoa = [
    ['REPORTE DE ESTUDIANTES'],
    [`Ciclo inicial: ${cicloInicial || 'Todos'}`],
    [`Ciclo final: ${cicloFinal || 'Todos'}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
    [`Total de registros: ${resultados.length}`],
    [],
    COLUMNAS,
  ];

  resultados.forEach((row, idx) => {
    aoa.push([
      idx + 1,
      row.nombre_ciclo || '',
      row.matricula || '',
      row.nombre_completo || '',
      row.seccion_nombre || '',
      row.programa_nombre || '',
      row.tipo_estudiante || '',
      row.turno || '',
      row.modalidad || '',
      row.estatus_display || '',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = [
    { wch: 6 },
    { wch: 18 },
    { wch: 16 },
    { wch: 34 },
    { wch: 18 },
    { wch: 32 },
    { wch: 20 },
    { wch: 16 },
    { wch: 16 },
    { wch: 18 },
  ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Inscritos');

  XLSX.writeFile(wb, `reporte_estudiantes_inscritos_${fechaArchivo()}.xlsx`);
}

export default exportReporteEstudiantesInscritosXLS;
